import { call, put, takeLatest } from "redux-saga/effects";
import {
  getDiseasesByFilter as getDiseasesByFilterService,
} from "../../services/diseases";
import * as types from "./types";

/**
 * Sagas du domaine Diseases (Phase 2.F).
 *
 * <p>Conventions Phase 2.D :
 * <ul>
 *   <li>{@code call(service, ...)} pour testabilité.</li>
 *   <li>Lecture de {@code result.ok} (plus de {@code result.success}).</li>
 *   <li>Pas de token mémorisé au chargement — apiRequest gère l'auth via
 *       le storage.</li>
 * </ul>
 *
 * <p>Le service {@code getDiseasesByFilter} est un alias rétro-compatible
 * vers {@code GET /diseases?search&page&size} : il aplatit la réponse
 * paginée en tableau plat, donc {@code result.data} est directement le
 * {@code content} — on le stocke tel quel dans {@code diseases}.
 */
function* getDiseasesByFilter({ payload }) {
  try {
    const result = yield call(getDiseasesByFilterService, payload || {});
    if (!result?.ok) {
      yield put({ type: types.GET_DISEASES_BY_FILTER_FAILURE, payload: [] });
      return;
    }
    yield put({
      type: types.GET_DISEASES_BY_FILTER_SUCCESS,
      payload: result?.data || [],
    });
  } catch (error) {
    console.error("GetDiseasesByFilterSagaErr: ", error);
    yield put({ type: types.GET_DISEASES_BY_FILTER_FAILURE, payload: [] });
  }
}

export default function* DiseasesSaga() {
  yield takeLatest(types.GET_DISEASES_BY_FILTER_REQUEST, getDiseasesByFilter);
}
